import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../../lib/net";
import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Fkn_Tv extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.tba = [];

        this.state.tot = {};
        this.state.tot.netto = "";
        this.state.tot.brutto = "";
        this.state.tot.resultat = "";

        this.state.today = new Date();
        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;
    }
    componentDidMount(){
        this.tb_view();
    }

    componentWillUnmount(){
    }

    onScroll(event) {
        var body = document.getElementById("web-body");
        if (body.scrollTop > 150) {
          this.setState({top: 0})
          this.setState({info: 'small'})
        } else {
          this.setState({top: 1})
          this.setState({info: 'big:'+body.scrollTop})
        }

        if (true) {
            var offset = body.scrollTop;
            var start = body.scrollTop;
            var slut = body.scrollTop + window.innerHeight;

            for(var mnuid of this.state.mnus) {
                const element = document.getElementById(mnuid);
                if(!element || (element == null) || (element == undefined)) continue;
                var eltop = element.offsetTop;
                var elbot = element.offsetTop + element.offsetHeight;
                var brc = eltop >= start && eltop <= slut;
                //if(!brc) brc = elbot >= start && elbot <= slut;
                if(brc) {
                    this.setState({mnu_sel: mnuid});
                    return;
                }
            }
        }
    }
    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    body_style() {
        var css = {};
        css.overflow = "auto"
        css.background = "#fafafa"
        css.width = "100%"
        css.textAlign = "center"
        css.height = window.innerHeight - 200;
        return css;
    }
  
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }
    tb_css(tbo) {
        var css = {};
      var xoff = 0;
      var yoff = 0;
      var bg = "dedede";
      var fg = "000";

      css.position = "absolute";
      css.border = "1px #000 solid";
      css.textAlign = "center";

      var xpos = (tbo.bordX * 1) + xoff;
      var ypos = (tbo.bordY * 1) + yoff;
      var xlen = tbo.bordXlen * 1;
      var ylen = tbo.bordYlen * 1;

      if(tbo.orientation == "090") {
          var xtmp = xlen;
          xlen = ylen;
          ylen = xtmp;
          bg = "ff9900";
      }

      css.left = xpos + "px";
      css.top = ypos + "px";
      css.width = xlen + "px";
      css.height = ylen + "px";
      css.lineHeight = ylen + "px";
      css.background = "#" + bg;
      css.color = "#" + fg;


      if(tbo.bordsname.trim() == "RECTANGULAR") {
          var radius = 5;
          css.borderRadius = radius + "px";
      }
      if(tbo.bordsname.trim() == "OVAL") {
          var radius = xlen / 2;
          css.borderRadius = radius + "px";
      }
      if(tbo.bordsname.trim() == "ROUND") {
          var radius = xlen / 2;
          css.borderRadius = radius + "px";
      }

      return css;
    }  
    tb_view() {
        var self = this;
    
        var prm = {};
        //prm.req = "pms.rs_lt.lt_tbs";
        prm.req = "pos.pos_tbv.tbv";
        //prm.rs = this.state.rs;
        prm.rs = "BISTRO";
    
        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));
            self.setState({tba: ret.rca });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
      }
    
    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">


            <div className="d-flex flex-row justify-content-between">
                <div className="">BORDS VY</div>
            </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="cdiblue" onClick={() => this.st_oms() }>UPPDATERA</div>
                </div>

        <div id="tbvbody" className="web-row">
        <div style={ this.body_style() }>
        <div
            style={{position: "relative",width: "1024px", height:"768px",margin: "0px auto",background: "#fff"}}
        >

            { this.state.tba.map((tbo, key) =>
            <div key={ key }
                style={ this.tb_css(tbo) }
            >
            { tbo.bordsnr }
            </div>
            )}

        </div>
    </div>
    </div>


         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Fkn_Tv;
